const datosAliados = {
  amazonas: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  anzoategui: {
    distribuidoras: [
      {
        nombre: 'ZAKIPHARMA, C.A.',
        email: 'ZAKIDROGUERIA@GMAIL.COM',
        direccion:
          'AV PROLONGACION PASEO COLON CRUCE CON CALLE LA ENSENADA LOCAL NIVEL P5, LOCAL GALPON NRO 1 SECTOR EL PARAISO PUERTO LA CRUZ ANZOATEGUI',
        telefono: '0412-3923506',
      },
    ],
  },
  apure: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  aragua: {
    distribuidoras: [
      {
        nombre: 'HARISSA DROGUERÍA, C.A.',
        email: 'COMPRAS.HARISSADROGUERIA@GMAIL.COM',
        direccion:
          'CALLE SUCRE CRUCE CON CALLE RONDON LOCAL CORAZON DE JESUS PLANTA BAJA NRO. LC 03 SECTOR CENTRO DE CAGUA',
        telefono: '0412-8942140',
      },
    ],
  },
  barinas: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA JOSKAR C.A.',
        email: 'drogueriajoskar@hotmail.com',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0412-9752737',
      },
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  bolivar: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  carabobo: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA VENEZOLANA DEL CENTRO, C.A',
        email: '',
        direccion:
          'CALLE 1, PARCELA MGI Y MGII, URB INDUSTRIAL CASTILLETE LOS ARALES. MUNICIPIO SAN DIEGO. PARROQUIA URBANA SAN DIEGO. VALENCIA. ESTADO CARABOBO',
        telefono: '0412-8003109',
      },
      {
        nombre: 'REDVITAL COMERCIALIZADORA, C.A.',
        email: 'PURCHASE16@DYNAMICS.LIFE',
        direccion:
          'AV PRINCIPAL LOCAL LOTE 95-A-351 SECTOR FUNDO LOS MANIRES, SAN DIEGO VALENCIA - CARABOBO',
        telefono: '0414-4207648',
      },
    ],
  },
  cojedes: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  deltaamacuro: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },

  caracas: {
    distribuidoras: [
      {
        nombre: 'FARMATODO, C.A.',
        email: '',
        direccion:
          'CENTRO COMERCIAL EXPRESO, AV. LOS GUAYABITOS SECTOR PIEDRA AZUL, PISO 1',
        telefono: '0424-3213194',
      },
    ],
  },
  falcon: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  guarico: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  vargas: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  lara: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA BIOGENETICA, C.A',
        email: 'BIOGENETICA05@YAHOO.ES',
        direccion:
          'CALLE 17 ENTRE CARRERA 18 Y 19 CASA NIVEL PB NUMERO 18 -52 SECTOR ESTE BARQUISIMETO LARA',
        telefono: '0414-9579009',
      },
      {
        nombre: 'DROGUERIA NENA C.A.',
        email: 'ALICIA.LOAIZA@DRONENA.COM',
        direccion:
          'CR3 CON CALLE3 EDI DRONENA PISO OF ZONA INDUSTRIAL III BARQUISIMETO LARA',
        telefono: '0414-9135401',
      },
      {
        nombre: 'DROGUERIA SANTO REMEDIO, C.A.',
        email: 'analistacompras2@drogueriasantoremedio.com',
        direccion:
          'CALLE 6 ENTRE CARRETERA 5 Y 6 EDIF GALPON PB LOCAL PARCELA 106 URB INDUSTRIAL NUMERO 2 BARQUISIMENTO ESTADO LARA',
        telefono: '0414-5561732',
      },
    ],
  },
  merida: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA EL BIENESTAR DROBIENCA, C.A.',
        email: 'contacto@drobianca.com',
        direccion:
          'AV. ALFREDO BRICEÑO PAREDES. EDIF. COMERCIAL SIGNADO, NRO. 18 PISO PB LOCAL 18PB, 18P1, 18P2. ZONA INDUSTRIAL RAMÓN EDUARDO SANDIA. MERIDA MERIDA',
        telefono: '0414-18080090',
      },
      {
        nombre: 'DROGUERIA MEGA C.A.',
        email: 'info@megadrogeria.com',
        direccion:
          'CALLE 1ERA ZONA INDUSTRTIAL LOS CUROS LOCAL GALPON NUM B-13 SECTOR ZONA INDUSTRIAL LOS CUROS MERIDA.',
        telefono: '0416-12345678',
      },
    ],
  },

  miranda: {
    distribuidoras: [
      {
        nombre: 'EL MASTRANTO M & M, C.A.',
        email: '',
        direccion:
          'CALLE NUCLEO INDUSTRIAL LA LLOVIZNA, LOS VECINOS LOCAL NUCLEO INDUSTRIAL LA LLOVIZNA, LOS VECINOS NRO 3-B SECTOR LA LLOVIZNA CARRIZAL MIRANDA',
        telefono: '0426-9150418',
      },
    ],
  },
  monagas: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA INTERCONTINENTAL, C.A',
        email: '',
        direccion:
          'AV CRUZ PERAZA LOCAL GALPO NRO 02  SECTOR CARBONERA MATURIN  MONAGAS',
        telefono: '0424-9219521',
      },
      {
        nombre: 'DROGUERIA VITALCLINIC, C.A.',
        email: '',
        direccion:
          'AV ROMULO GALLEGOS LOCAL EMPRESARIAL NRO 1 Y 2 URB EL PARQUE MATURIN MONAGAS',
        telefono: '0424-9127427',
      },
      {
        nombre: 'FARMA DON ORIENTE , C.A.',
        email: '',
        direccion:
          'CALLE AZCUE, EDIF FABRIZZIO, PISO 1, LOCAL 1, SECTOR CENTRO MATURIN, MONAGAS',
        telefono: '0424-9346975',
      },
      {
        nombre: 'INSUAMINCA, C.A.',
        email: 'COMPRAS@INSUAMINCA.COM',
        direccion:
          'AV CRUZ PERAZA LOCAL COMPLEJO  INDUSTRIAL  EL TEIDE GALPON  NRO 3, MATURIN EDO MONAGAS.',
        telefono: '0412-1076259',
      },
      {
        nombre: 'REPRESENTACIONES VERONA, C.A.',
        email: '',
        direccion:
          'CALLE AZCUE EDIF FABRIZZIO PISO PB SECTOR CENTRO  MATURIN-  MONAGAS',
        telefono: '0426-4120573',
      },
    ],
  },
  nuevaesparta: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  portuguesa: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  sucre: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  tachira: {
    distribuidoras: [
      {
        nombre: 'CRIST MEDICALS, C.A.',
        email: 'comprascristmedicals@gmail.com',
        direccion:
          'CALLE PASAJE BARCELONA LOCAL GALPON NRO 3, ZONA INDUSTRIAL DE PUENTE REAL SAN CRISTOBAL - TACHIRA.',
        telefono: '0276-3460426',
      },
      {
        nombre: 'DROGUERIA JAYE C.A',
        email: 'DROGUERIAJAYEVENTAS2@GMAIL.COM',
        direccion:
          'AV LA GUAYANA CC PASEO LA VILLA, BLOQUE B1 NIVEL 3 LOCAL B1-18 URB. SANTA INÉS SAN CRISTÓBAL TACHIRA ZONA POSTAL 5001',
        telefono: '0414-7033787',
      },
      {
        nombre: 'DROGUERIA SYMCA C.A. DROSYMCA',
        email: 'COMPRAS01@DROSYMCA.COM',
        direccion:
          'CALLE 5 BIS QTA NRO  2-76  NRO  2-68, URBANIZACIÓN MERIDA. SAN CRISTOBAL  TACHIRA',
        telefono: '0424-7563761',
      },
    ],
  },
  zulia: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA ACTIVA, C.A.',
        email: '',
        direccion:
          'AV. 12 ENTRE CALLE 66-A Y 67 CECILIO ACOSTA LOCAL NRO. 66-A-73 SECTOR TIERRA NEGRA MARACAIBO ESTADO ZULIA',
        telefono: '0412-6911404',
      },
      {
        nombre: 'DROGUERIA DROMARKO, C.A.',
        email: 'EBASTIDAS@DROMARKO.COM',
        direccion:
          'CALLE 92 A ESQUINA AV 3 Y 3A EDIF LA BORINQUEÑA PISO PB LOCAL PB SECTOR SANTA LUCIA MARACAIBO -  ZULIA',
        telefono: '0424-6614939',
      },
      {
        nombre: 'DROGUERIA FARMACEUTICA 24, C.A.',
        email: 'SUPERVISOR.COMPRAS@FARMACEUTICA24.COM',
        direccion:
          'AV 17 EDIF GALPON 1 PISO - LOCAL N° 258 SECTOR LOS HATICOS MARACAIBO - ZULIA ZONA POSTAL 4001',
        telefono: '0414-6060133',
      },
      {
        nombre: 'DROGUERIA Y SUMINISTROS DROFARZUCA, C.A.',
        email: 'DROFARZUCA@GMAIL.COM',
        direccion:
          'CALLE 83 CASA NRO 28-16 SECTOR SANTA MARIA MARACAIBO - ZULIA.',
        telefono: '0261-8145497 / 0261-6173216',
      },
    ],
  },
  yaracuy: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
  trujillo: {
    distribuidoras: [
      {
        nombre: 'DROGUERIA SAN GREGORIO, C.A',
        email: 'COMPRAS.SANGREGORIOCA@GMAIL.COM',
        direccion:
          'AV EL LLANERO ESQUINA CALLE 6 EDIF CHAHINE PISO PLANTA LOCAL 1 SECTOR CENTRO SABANETA BARINAS',
        telefono: '0426-5520017',
      },
    ],
  },
};

export default datosAliados;
